import { useParams } from 'react-router-dom';

import { ensureDefined, invariant } from '@e-socna/utils';
import type { Id } from '@e-socna/data-layer';

import { checkIfIsId } from './check-if-is-id.util';

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
export const useIdParam = <I extends Id = Id>(paramName = 'id'): I => {
  const params = useParams();

  const { id } = ensureDefined({ id: params[paramName] });

  invariant(checkIfIsId(id), `Invalid "${paramName}" parameter`);

  return id as I;
};
